import 'dynamic-import-polyfill';
import React, { lazy } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
// 移除直接导入，改为懒加载
// import { DndProvider } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';

// 懒加载 DndProvider
const LazyDndProvider = React.lazy(async () => {
  const [{ DndProvider }, { HTML5Backend }] = await Promise.all([
    import('react-dnd'),
    import('react-dnd-html5-backend')
  ]);
  
  // 创建一个包装组件，包含 backend
  const DndProviderWrapper = ({ children }: { children: React.ReactNode }) => (
    <DndProvider backend={HTML5Backend}>
      {children}
    </DndProvider>
  );
  
  return { default: DndProviderWrapper };
});

// 获取根元素
const container = document.getElementById('root');

// 使用 createRoot API 渲染 App 组件
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <React.Suspense fallback={<div>Loading...</div>}>
        <LazyDndProvider>
          <App />
        </LazyDndProvider>
      </React.Suspense>
    </React.StrictMode>
  );
}
